import {
  AdminprofileImage,
  Btn,
  AnimateSpin,
  MainHeading,
  Pagination,
  Text,
} from '../../components/index';
import Icons from '../../assets/icons/index.js';
import ServicesFunctional from './index.function.js';
import { fontSizes } from '../../constants/constants.js';
const SelectCard = () => {
  const {
    isLoading,
    handleButtonClick,
    handlePageChange,
    totalPages,
    currentPage,
    totalItems,
    service,
    TextWeight,
  } = ServicesFunctional();
  return (
    <div className='flex-1 flex flex-col h-screen px-4 lg:px-12 pt-10'>
      <AdminprofileImage />
      <MainHeading
        Icon={Icons.HomeBlackIcon}
        heading={'Select Your Service'}
        paragraph={
          'Choose the service that best fits your needs from the options below to help us provide the most relevant solutions tailored to your requirements.'
        }
      />
      <div className='flex-1 overflow-y-auto h-full hide-scrollbar px-2 py-2'>
        {isLoading === true ? (
          <AnimateSpin />
        ) : (
          <div className='grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-3 gap-6 sm:gap-5 2xl:gap-12 3xl:gap-20'>
            {service?.data?.map((val, index) => (
              <div
                key={index}
                className='bg-[#F6F6F6] shadow-custom-gray rounded-[40px] flex items-center flex-col py-10 xl:py-12 2xl:py-16 3xl:py-20'
              >
                <div className='bg-secondary w-[144px] h-[144px] flex justify-center shadow-custom-gray items-center rounded-[50%] custom-gray'>
                  <img
                    className='lg:w-[50%] w-20'
                    src={`${val?.image}`}
                    alt={val?.name}
                  />
                </div>
                <Text
                  text={val?.name}
                  size={fontSizes.h30}
                  weight={TextWeight.Raleway_SemiBold}
                  color='text-black'
                  isCenter={true}
                  isTruncate={false}
                  className={' max-w-96 my-5 lg:my-6 xl:my-10 2xl:my-12'}
                />
                <Btn
                  type={'button'}
                  onClick={() => handleButtonClick(val?._id, val?.categories)}
                  isprimary={false}
                  weight={TextWeight.Raleway_SemiBold}
                  textSize={fontSizes.h18}
                  text={'Get Started'}
                  color='text-white hover:text-primary'
                  bgColor={
                    'bg-primary hover:bg-white hover:border-primary border-transparent'
                  }
                  className={'mx-auto'}
                />
              </div>
            ))}
          </div>
        )}
      </div>
      <div className='pb-4 sm:pb-7 lg:pb-10 pt-2'>
        <div className='w-full flex justify-center'>
          {totalItems > 3 && (
            <Pagination
              currentPage={currentPage}
              totalPages={totalPages}
              onPageChange={handlePageChange}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default SelectCard;
